<!--
  LE-027 (audit 2026-06-04): "الإعدادات العامة" was still a ComingSoon placeholder,
  violating §11.3 ("dead /ComingSoon links must be removed or replaced with real
  pages"). This replaces it with a real settings hub that links to every existing
  system-settings page, so the menu entry now opens a working, navigable page.
-->
<template>
  <div class="container-fluid py-4">
    <div class="d-flex align-items-center mb-4">
      <i class="ti ti-settings" style="font-size:28px; margin-inline-end:10px; color:#4f46e5;"></i>
      <div>
        <h4 class="mb-0 fw-bold">الإعدادات العامة</h4>
        <small class="text-muted">مركز إعدادات النظام — اختر القسم الذي تريد تعديله</small>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-12 col-sm-6 col-lg-4" v-for="card in cards" :key="card.route">
        <div class="card h-100 settings-card" role="button" tabindex="0"
             @click="href(card.route)" @keyup.enter="href(card.route)">
          <div class="card-body d-flex align-items-start gap-3">
            <div class="settings-icon" :style="{ background: card.tint }">
              <i :class="card.icon"></i>
            </div>
            <div>
              <h6 class="mb-1 fw-bold">{{ card.title }}</h6>
              <small class="text-muted">{{ card.desc }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralSettings',
  data() {
    return {
      cards: [
        { title: 'التسعير الديناميكي', desc: 'الأسعار والمضاعفات لكل فئة', route: '/Pricing', icon: 'ti ti-currency-dollar', tint: '#eef2ff' },
        { title: 'قواعد العمولة', desc: 'نِسَب العمولة حسب الفئة والشريحة', route: '/CommissionRules', icon: 'ti ti-percentage', tint: '#ecfeff' },
        { title: 'أنواع الرحلات والمركبات', desc: 'فئات الرحلات وأنواع المركبات', route: '/VehicleTypes', icon: 'ti ti-car', tint: '#fef9c3' },
        { title: 'أنواع الاشتراكات', desc: 'باقات اشتراك السائقين', route: '/SubscriptionsTypes', icon: 'ti ti-id-badge-2', tint: '#f0fdf4' },
        { title: 'طرق الدفع', desc: 'وسائل الدفع المتاحة', route: '/PaymentMethods', icon: 'ti ti-credit-card', tint: '#fdf2f8' },
        { title: 'سياسة الإلغاء', desc: 'رسوم وقواعد الإلغاء', route: '/CancellationPolicy', icon: 'ti ti-ban', tint: '#fef2f2' },
        { title: 'المدن والبلديات والمواقع', desc: 'النطاق الجغرافي للخدمة', route: '/Cities', icon: 'ti ti-map-pin', tint: '#eff6ff' },
        { title: 'الأسئلة الشائعة (FAQ)', desc: 'محتوى المساعدة للمستخدمين', route: '/Faq', icon: 'ti ti-help-circle', tint: '#f5f3ff' },
        { title: 'محاكي الرسائل (SMS)', desc: 'سجل رسائل المحاكاة للاختبار', route: '/SmsSimulator', icon: 'ti ti-message-2', tint: '#f0f9ff' }
      ]
    };
  },
  methods: {
    href(url) {
      if (url !== this.$router.currentRoute.path) {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style scoped>
.settings-card { transition: box-shadow .15s ease, transform .15s ease; border: 1px solid #eef0f4; }
.settings-card:hover { box-shadow: 0 8px 24px rgba(15,23,42,.08); transform: translateY(-2px); }
.settings-icon {
  width: 44px; height: 44px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 20px; color: #4f46e5; flex: 0 0 auto;
}
</style>
